import { render } from "./Modal4.vue?vue&type=template&id=0f07250c&scoped=true"
import script from "./Modal4.vue?vue&type=script&lang=js"
export * from "./Modal4.vue?vue&type=script&lang=js"

import "./Modal4.vue?vue&type=style&index=0&id=0f07250c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f07250c"]])

export default __exports__